import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, message, Popconfirm, Image, Select } from 'antd';
import { getParlamentMembers, addParlamentMember, updateParlamentMember, deleteParlamentMember, PARTY_OPTIONS } from '../../services/parlamentMemberService';

const ParlamentMembers = () => {
  const [members, setMembers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  const [searchText, setSearchText] = useState('');

  const fetchMembers = async (params = {}) => {
    try {
      setLoading(true);
      const response = await getParlamentMembers({
        pageNum: params.current || 1,
        pageSize: params.pageSize || 10,
        searchTerm: params.searchTerm || searchText,
        sortBy: "createdAt desc" // En son eklenen üye en üste gelsin
      });

      if (response?.isSuccess) {
        setMembers(response.data.items || []);
        setPagination({
          ...pagination,
          total: response.data.totalCount || 0,
          current: params.current || 1
        });
      } else {
        message.error('Üyeler yüklenemedi');
      }
    } catch (error) {
      console.error('Error fetching members:', error);
      message.error('Üyeler yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers({
      current: pagination.current,
      pageSize: pagination.pageSize
    });
  }, []);

  const handleTableChange = (newPagination, filters, sorter) => {
    fetchMembers({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      sortBy: sorter.field,
      ...filters
    });
  };

  const columns = [
    {
      title: 'Fotoğraf',
      dataIndex: 'pictureUrl',
      key: 'pictureUrl',
      render: (pictureUrl) => (
        <Image
          src={pictureUrl}
          alt="Üye"
          style={{ width: 100 }}
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
        />
      ),
    },
    {
      title: 'Ad Soyad',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'Parti',
      dataIndex: 'partyName',
      key: 'partyName',
      render: (partyName, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: record.partyColor || '#ccc'
            }}
          />
          {partyName}
        </div>
      ),
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button 
            type="primary" 
            onClick={() => handleEdit(record)} 
            style={{ marginRight: 8 }}
          >
            Düzenle
          </Button>
          <Popconfirm
            title="Bu üyeyi silmek istediğinizden emin misiniz?"
            onConfirm={() => handleDelete(record.guid)}
            okText="Evet"
            cancelText="Hayır"
          >
            <Button danger>Sil</Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  const handleEdit = (member) => {
    console.log('Düzenleye basıldı, içeri dolan veri:', member);
    setEditingMember(member);
    form.setFieldsValue({
      name: member.name,
      partyName: member.partyName
    });
    setIsModalVisible(true);
  };

  const handleDelete = async (guid) => {
    try {
      setLoading(true);
      const response = await deleteParlamentMember(guid);
      if (response.isSuccess) {
        message.success('Üye başarıyla silindi');
        fetchMembers({
          current: pagination.current,
          pageSize: pagination.pageSize
        });
      } else {
        message.error('Üye silinirken bir hata oluştu');
      }
    } catch (error) {
      console.error('Delete error:', error);
      message.error('Üye silinirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setEditingMember(null);
    setIsModalVisible(false);
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      console.log('Form values:', values);
      console.log('Editing member:', editingMember);
      
      // Parti rengini bul
      const selectedParty = PARTY_OPTIONS.find(party => party.name === values.partyName);
      
      const submitData = {
        name: values.name,
        partyName: values.partyName,
        partyColor: selectedParty ? selectedParty.color : '#000000'
      };

      // Güncelleme işleminde guid ekle
      if (editingMember) {
        submitData.guid = editingMember.guid;
      }

      // Resim kontrolü
      if (form.getFieldValue('pictureBase64')) {
        console.log('Yeni resim yükleniyor');
        submitData.pictureUrl = form.getFieldValue('pictureBase64');
      } else {
        console.log('Resim değişmedi, boş pictureUrl gönderiliyor');
        submitData.pictureUrl = '';
      }

      console.log('Güncellenecek veri:', submitData);

      console.log('Submit data:', submitData);
      let response;
      if (!editingMember) {
        // Add new member
        console.log('Yeni üye ekleniyor:', JSON.stringify(submitData, null, 2));
        response = await addParlamentMember(submitData);
        if (response?.isSuccess) {
          message.success('Üye başarıyla eklendi');
          resetForm();
          setSearchText(''); // Aramayı sıfırla
          await fetchMembers({
            current: 1,
            pageSize: pagination.pageSize,
            searchTerm: '',
            sortBy: 'createdAt desc'
          });
        } else {
          message.error('Üye eklenirken bir hata oluştu');
          return; // Hata durumunda formu kapatma
        }
      } else {
        // Update existing member
        const updateData = {
          ...submitData,
          guid: editingMember.guid
        };
        console.log('Update data:', updateData);
        try {
          console.log('API çağrısı yapılıyor...');
          console.log('Gönderilen veri:', JSON.stringify(updateData, null, 2));
          const response = await updateParlamentMember(updateData);
          console.log('API yanıtı:', JSON.stringify(response, null, 2));

          if (response?.isSuccess) {
            message.success('Üye başarıyla güncellendi');
            resetForm();
            await fetchMembers({
              current: pagination.current,
              pageSize: pagination.pageSize,
              searchTerm: searchText,
              sortBy: 'createdAt desc'
            });
          } else {
            throw new Error('API yanıtı başarısız');
          }
        } catch (updateError) {
          console.error('Güncelleme hatası:', updateError);
          console.error('Hata detayı:', updateError.response?.data);
          message.error('Üye güncellenirken bir hata oluştu: ' + (updateError.response?.data?.message || updateError.message));
          return; // Hata durumunda formu kapatma
        }
      }
    } catch (error) {
      console.error('Submit error:', error);
      message.error('İşlem sırasında bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        form.setFieldsValue({
          pictureBase64: reader.result.split(',')[1]
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', gap: '8px' }}>
        <input
          type="text"
          placeholder="Üye ara..."
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            fetchMembers({
              current: 1,
              pageSize: pagination.pageSize,
              searchTerm: e.target.value
            });
          }}
          className="ant-input"
          style={{ width: 200 }}
        />
        <Button
          type="primary"
          onClick={() => {
            setEditingMember(null);
            form.resetFields();
            setIsModalVisible(true);
          }}
        >
          Yeni Üye Ekle
        </Button>
      </div>

      <Table 
        columns={columns} 
        dataSource={members} 
        rowKey="guid"
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
      />

      <Modal
        title={editingMember ? 'Üyeyi Düzenle' : 'Yeni Üye Ekle'}
        open={isModalVisible}
        onCancel={() => {
          resetForm();
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="name"
            label="Ad Soyad"
            rules={[{ required: true, message: 'Lütfen ad soyad giriniz' }]}
          >
            <input type="text" className="ant-input" />
          </Form.Item>

          <Form.Item
            name="partyName"
            label="Parti"
            rules={[{ required: true, message: 'Lütfen parti seçiniz' }]}
          >
            <Select>
              {PARTY_OPTIONS.map(party => (
                <Select.Option key={party.name} value={party.name}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div
                      style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: party.color
                      }}
                    />
                    {party.name}
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="pictureBase64"
            label="Fotoğraf"
            hidden
          >
            <input type="hidden" />
          </Form.Item>

          <Form.Item
            label="Fotoğraf"
          >
            <input 
              type="file" 
              onChange={handleFileChange} 
              accept="image/*" 
              key={editingMember ? 'edit' : 'add'}
            />
            {editingMember?.pictureUrl && (
              <div style={{ marginTop: 8 }}>
                <Image
                  src={editingMember.pictureUrl}
                  alt="Mevcut Fotoğraf"
                  style={{ width: 100 }}
                />
                <div style={{ marginTop: 4, color: '#666' }}>
                  Yeni fotoğraf seçmezseniz mevcut fotoğraf kullanılacaktır
                </div>
              </div>
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editingMember ? 'Güncelle' : 'Ekle'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ParlamentMembers;
